import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, getStoredToken } from "@shared/utils/tokenUtils";

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function PublicRoute({
  children,
  redirectTo = "/admin/dashboard",
}: PublicRouteProps) {
  const location = useLocation();
  const token = typeof window !== "undefined" ? getStoredToken() : null;
  const valid = token ? isTokenValid(token) : false;

  // Si hay token válido, redirigir al dashboard o a "from"
  if (valid) {
    // Si viene de una ruta protegida, redirigir a esa ruta
    const from = location.state?.from?.pathname;
    return <Navigate to={from || redirectTo} replace />;
  }

  // Si no está autenticado o no es admin, mostrar el contenido (login)
  return <>{children}</>;
}
